import { Provider } from 'react-redux';

import { ProvidersContext } from '@/contexts';
import { store } from '@/redux/store';
import { QueryProvider } from './QueryProvider';

export function Providers({
  children,
}: {
  readonly children: React.ReactNode;
}) {
  return (
    <QueryProvider>
      <ProvidersContext>
        <Provider store={store}>{children}</Provider>
      </ProvidersContext>
    </QueryProvider>
  );
}
